import script from "./WageSimpleDiagnosisDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageSimpleDiagnosisDialog.vue?vue&type=script&setup=true&lang=ts"

import "./WageSimpleDiagnosisDialog.vue?vue&type=style&index=0&id=21d7bbe3&lang=scss"

const __exports__ = script;

export default __exports__